export default __webpack_public_path__ + "static/media/FS-TUTORIALES-ICONO-MAGENTA.5a543625.svg";